import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SalesRegion, Territory, TerritoryPostCodeReportData } from 'src/app/common/model/shared.model';
import { environment } from 'src/environments/environment';
import { TextDataResponse } from 'src/app/common/model/TextDataResponse';

@Injectable({
    providedIn: 'root'
})


export class TerritoryService {

    baseurl = environment.apiBaseUrl;

    constructor(protected http: HttpClient) { }

    getSalesRegionList() {
        return this.http.get<SalesRegion[]>(this.baseurl + 'SalesRegion/getvalidsalesregion');
    }

    getTerritoryListBySalesRegionByArray(salesRegionIds: number[]) {
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json'
            })
        };
        return this.http.post<Territory[]>(this.baseurl + 'Territory/getterritoriesbysalesregionsarray', JSON.stringify(salesRegionIds, null, 2), httpOptions);
    }

    getTerritoryPostcodeReportData(territoryIds : number[]) : Observable<TextDataResponse>{
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json'
            })
        };
        return this.http.post<TextDataResponse>(this.baseurl + 'Territory/getterritorypostcodereport', JSON.stringify(territoryIds, null, 2), httpOptions);
    }
}
